// import type { SanityImageSource } from "@sanity/asset-utils";
// import createImageUrlBuilder from "@sanity/image-url";
import { createClient } from "next-sanity";

import { apiVersion, dataset, projectId, studioUrl } from "./api";

export const client = createClient({
  projectId,
  dataset,
  apiVersion,
  // Server-only read token (undefined in the browser bundle — Next.js only
  // inlines NEXT_PUBLIC_* vars). Only used off-production: the anonymous
  // public view of staging lags behind / mirrors production, so staging reads
  // the live, authenticated dataset view. Production stays anonymous so server
  // reads come from the CDN.
  token:
    dataset === "production" ? undefined : process.env.SANITY_API_READ_TOKEN,
  // A token disables the CDN automatically; keep it off for tokened reads.
  useCdn: dataset === "production" && process.env.NODE_ENV === "production",
  perspective: "published",
  stega: {
    studioUrl,
    enabled: process.env.NEXT_PUBLIC_VERCEL_ENV === "preview",
  },
});

// const imageBuilder = createImageUrlBuilder({
//   projectId: projectId,
//   dataset: dataset,
// });

// export const urlFor = (source: SanityImageSource) =>
//   imageBuilder.image(source).auto("format").fit("max").format("webp");
